
// Render flash messages from a JSON AJAX response into the existing
// #flashMessages container. Pair with PHP ajax_die_with_flash().
// Accepts: { info, notice, warning, error, success } where each value is a
// (possibly empty) HTML string.
window.renderFlashMessages = function (flashMessage) {
    if (!flashMessage) { return; }
    var $container = $('#flashMessages');
    if (!$container.length) { return; }
    ['info', 'notice', 'warning', 'error', 'success'].forEach(function (type) {
        var text = flashMessage[type];
        if (!text) { return; }
        var $sub = $container.find('#flashMessages_' + type);
        var $target = $sub.length ? $sub : $container;
        var $msg = $('<div class="flashMessage flashMessage_' + type + '" role="alert"></div>')
            .html(text)
            .hide();
        $target.append($msg);
        $msg.fadeIn('slow');
        var hide = function () { $msg.fadeOut('slow', function () { $msg.remove(); }); };
        setTimeout(hide, 4000);
        $msg.on('click', hide);
    });
};

$(document).ready(function () {
    $('.modal-iframe').click(function () {
        var e = $(this);
        $('iframe', '#iframeContent').load(e.data("target"));
        $('#iframeContent').modal({show: true})
    });

    $('.share_popup').on("click", function (e) {
        e.preventDefault();
        var t = $(this).data("target"), r = "_blank", i = "600", n = "460", a = "width=" + i + ",height=" + n;
        window.open(t, r, a)
    });

    /* 	$('#itemcard_order_button_form_indiv select').attr('disabled', 'disabled');
     $('#itemcard_order_button_form_std select').removeAttr('disabled');
     */
    $('.itemcard_order_button_radio_wrapper_inner').change('input', function () {
        if ($('#itemcard_order_type_choice_1').is(":checked")) {
            $('#itemcard_order_button_form_indiv_outer').addClass('itemcard_order_button_inactive');
            $('#itemcard_order_button_form_std_outer').removeClass('itemcard_order_button_inactive');
            $('div[u="slides"] > div:nth-child(2) > div > img[cust_img="0"]').click();
            $('#itemcard_order_button_form_indiv select').attr('disabled', 'disabled');
            $('#itemcard_order_button_form_std select').removeAttr('disabled');
        } else {
            $('#itemcard_order_button_form_indiv_outer').removeClass('itemcard_order_button_inactive');
            $('#itemcard_order_button_form_std_outer').addClass('itemcard_order_button_inactive');
            $('div[u="thumbnavigator"] img[cust_img="1"]').click();
            $('#itemcard_order_button_form_std select').attr('disabled', 'disabled');
            $('#itemcard_order_button_form_indiv select').removeAttr('disabled');
        }
    });
    $('.customize_delete_pic').click(function (e) {
        var obj = $(this);
        e.preventDefault();
        var request = $.ajax({
            url: '/module/dcshop/b2c/ajax.php' + $(obj).attr('href'),
            method: "POST"
        });

        request.done(function (msg) {
            var obj2 = $(obj).parents(".cust_img_area")
            $(obj2).html(msg);
            $(obj2).on("change", "input[type='file']", function () {
                $(obj2).find('input[type="text"]').val(this.files[0].name);
            })
        });
    });

    $('.slidecontent_headline').click(function () {
        $(this).toggleClass('active');
        $(this).next('.slidecontent_content_container').slideToggle('fast');
    });

    $('#header_shop_icons .header_icon_search').click(function () {
        $('#header_4').slideToggle('fast');
        $('#header_4 #input_search').focus();
    });

    $("#form_search").submit(function (e) {
        if (!$("#form_search").find('#input_search').val()) {
            e.preventDefault(e);
            e.stopPropagation(e);
        }
    });

    var flashMessage = $('.flashMessage');
    var flashSpeed = 'slow';
    var flashDelay = '4000';
    $(window).load(function(){
        flashMessage.fadeIn(flashSpeed);

        $(function() {
            setTimeout(function() {
                flashMessage.fadeOut(flashSpeed);
            },flashDelay);
        });
        flashMessage.click(function(){
            $(this).fadeOut(flashSpeed);
        });
    });

    // $('.jumpmark').click(function (e) {
    //     e.preventDefault();
    //     scrolling($(this).attr('href'));
    // });

    //init isotope for collection
    if($('.dc_isotope .collection_wrapper.isList').length > 0) {

        var groupFilter = $.urlParam('group_filter');
        var groupFilterInit = "*";

        if (groupFilter != null && groupFilter != 0) {
            groupFilterInit = '.collection_group_' + groupFilter;
        }

        var $grid = $('.dc_isotope .collection_wrapper.isList').isotope({
            itemSelector: '.collection_list',
            layoutMode: 'masonry',
            filter: groupFilterInit
        });

        $('.dc_isotope .group_filter_area a').on('click', function (event) {
            event.preventDefault();
            var filterValue = $(this).attr('data-filter');
            if (filterValue != "*") {
                filterValue = "." + filterValue;
            }
            $grid.isotope({filter: filterValue});
            $(this).closest('.group_filter_area').children('.group_filter').removeClass('active');
            $(this).parent().addClass('active');
        });
    };
});

function changeBg(a, img1, img2) {
    if (!a) {
        return true;
    }
    if (a.style.backgroundImage == "url(" + img1 + ")") {
        a.style.backgroundImage = "url(" + img2 + ")";
    } else {
        a.style.backgroundImage = "url(" + img1 + ")";
    }
    return true;
}
function toggleOn(a) {
    var e = document.getElementById(a);
    if (!e) {
        return true;
    }
    e.style.display = "block";
    return true;
}
function toggleOff(a) {
    var e = document.getElementById(a);
    if (!e) {
        return true;
    }
    e.style.display = "none";
    return true;
}
function toggle(a) {
    var e = document.getElementById(a);
    if (e.style.display != "block") {
        if (!e) {
            return true;
        }
        e.style.display = "block";
    } else {
        e.style.display = "none";
    }
}
function toggleOnnb(a) {
    var e = document.getElementById(a);
    if (!e) {
        return true;
    }
    e.style.display = "";
    return true;
}
function toggleOffnb(a) {
    var e = document.getElementById(a);
    if (!e) {
        return true;
    }
    e.style.display = "none";
    return true;
}
function togglenb(a) {
    var e = document.getElementById(a);
    if (e.style.display != "") {
        if (!e) {
            return true;
        }
        e.style.display = "";
    } else {
        e.style.display = "none";
    }
}
function toggleByClass(a) {
    var e = document.getElementByClassName(a);
    if (e.style.display != "block") {
        if (!e) {
            return true;
        }
        e.style.display = "block";
    } else {
        e.style.display = "none";
    }
}
function MM_jumpMenu(targ, selObj, restore) { //v3.0
    window[targ].location = selObj.options[selObj.selectedIndex].value;
    if (restore) {
        selObj.selectedIndex = 0;
    }
}
function openPopup(URL, WIDTH, HEIGHT) {
    if (!WIDTH) {
        WIDTH = 600;
    }
    if (!HEIGHT) {
        HEIGHT = 600;
    }
    WIDTH = 600;
    HEIGHT = 600;
    var popup = window.open(URL, "popup", "width=" + WIDTH + ", height=" + HEIGHT + ", scrollbars=no");
}
var currentLayer, currentTab, expectedHash;

function showLayer(lyr) {
    makeHistory(lyr);
    document.getElementById(currentLayer).className = 'hide';
    document.getElementById(lyr).className = 'show';
    currentLayer = lyr;
}
function showTab(lyr) {
    document.getElementById(currentTab).className = 'taboff';
    document.getElementById(lyr).className = 'tabon';
    currentTab = lyr;
}
function makeHistory(newHash) {
    window.location.hash = "_" + newHash;
    expectedHash = window.location.hash;
    return true;
}
function handleHistory() {
    if (window.location.hash != expectedHash) {
        expectedHash = window.location.hash;
        if (expectedHash.match('tab')) {
            showLayer(expectedHash.substring(2));
        }
    }
    return true;
}
function pollHash() {
    handleHistory();
    window.setInterval("handleHistory()", 200);
    return true;
}
function toggleDiv(id) {
    /*
     var obj=document.getElementsByTagName("div");
     for(i=0;i<obj.length;i++) {
     if(obj[i].collectionEntityClassName =="func") {
     obj[i].style.display="none";
     }
     }
     */
    if (document.getElementById(id).style.display == 'none') {
        document.getElementById(id).style.display = 'block';
        document.getElementById('head_' + id).className = 'function_cat open';
    } else {
        document.getElementById(id).style.display = 'none';
        document.getElementById('head_' + id).className = 'function_cat closed';
    }
}
function MM_swapImgRestore() { //v3.0
    var i, x, a = document.MM_sr;
    for (i = 0; a && i < a.length && (x = a[i]) && x.oSrc; i++) {
        x.src = x.oSrc;
    }
}
function MM_preloadImages() { //v3.0
    var d = document;
    if (d.images) {
        if (!d.MM_p) {
            d.MM_p = new Array();
        }
        var i, j = d.MM_p.length, a = MM_preloadImages.arguments;
        for (i = 0; i < a.length; i++) {
            if (a[i].indexOf("#") != 0) {
                d.MM_p[j] = new Image;
                d.MM_p[j++].src = a[i];
            }
        }
    }
}
function MM_findObj(n, d) { //v4.01
    var p, i, x;
    if (!d) {
        d = document;
    }
    if ((p = n.indexOf("?")) > 0 && parent.frames.length) {
        d = parent.frames[n.substring(p + 1)].document;
        n = n.substring(0, p);
    }
    if (!(x = d[n]) && d.all) {
        x = d.all[n];
    }
    for (i = 0; !x && i < d.forms.length; i++) {
        x = d.forms[i][n];
    }
    for (i = 0; !x && d.layers && i < d.layers.length; i++) {
        x = MM_findObj(n, d.layers[i].document);
    }
    if (!x && d.getElementById) {
        x = d.getElementById(n);
    }
    return x;
}
function MM_swapImage() { //v3.0
    var i, j = 0, x, a = MM_swapImage.arguments;
    document.MM_sr = new Array;
    for (i = 0; i < (a.length - 2); i += 3) {
        if ((x = MM_findObj(a[i])) != null) {
            document.MM_sr[j++] = x;
            if (!x.oSrc) {
                x.oSrc = x.src;
            }
            x.src = a[i + 2];
        }
    }
}

// (bootstrap-datepicker German locale removed — flatpickr handles localisation via the
//  shared layout/shared/js/flatpickr-init.js module)



function isTouchDevice() {
    var el = document.createElement('div');
    el.setAttribute('ontouchstart', 'return;');
    if(typeof el.ontouchstart == "function"){
        return true;
    }else {
        return false
    }
}


function scrolling(tabcontent_id) {
    var ziel = $(tabcontent_id);
    var top = ziel.offset().top;
    var heightHeader = $('#header').outerHeight();
    $('html,body').animate({
        scrollTop: top - heightHeader
    }, 800);
}

//mejs.i18n.language('de');

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);
    if (results==null){
        return null;
    }
    else{
        return results[1] || 0;
    }
}

// Expose to window for inline onclick handlers in PHP templates
window.toggle = toggle;
window.toggleOn = toggleOn;
window.toggleOff = toggleOff;
window.togglenb = togglenb;
window.toggleOnnb = toggleOnnb;
window.toggleOffnb = toggleOffnb;
window.toggleByClass = toggleByClass;
window.toggleDiv = toggleDiv;
window.changeBg = changeBg;
window.openPopup = openPopup;
window.showLayer = showLayer;
window.showTab = showTab;
window.MM_jumpMenu = MM_jumpMenu;
window.MM_swapImage = MM_swapImage;
window.MM_swapImgRestore = MM_swapImgRestore;
window.MM_preloadImages = MM_preloadImages;
window.scrolling = scrolling;